import React, { ReactNode } from 'react'

import { FooterContainer } from 'Footer'
import { Header } from 'Header'

type FullPageProps = {
  children: ReactNode
  route: {
    props: {
      footerType?: string
      footerIsOnLandingPage: boolean
    }
  }
}
export const FullPage = ({
  children,
  route: {
    props: { footerIsOnLandingPage, footerType },
  },
}: FullPageProps) => (
  <>
    <Header />
    {children}
    <FooterContainer type={footerType} copyright isOnLandingPage={footerIsOnLandingPage} />
  </>
)
